'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PlaceMent = exports.PlaceMent = ['top', 'bottom'];